import { useEffect, useState } from "react";
import axios from "axios";
import { BACKEND_URL, DEFAULT_VIDEOS } from "../data/site";

const EMPTY = { links: {}, upcoming: { enabled: true, title: "", teaser: "", release_date: null, cover: "" }, videos: DEFAULT_VIDEOS, songs: [], photos: [] };

export const useContent = () => {
  const [content, setContent] = useState(EMPTY);
  useEffect(() => {
    if (!BACKEND_URL) return undefined;
    let alive = true;
    axios.get(`${BACKEND_URL}/api/content`).then(({ data }) => {
      if (!alive) return;
      const videos = Array.isArray(data?.videos) && data.videos.length ? data.videos : DEFAULT_VIDEOS;
      setContent({
        links: data?.links ?? {},
        upcoming: data?.upcoming ?? EMPTY.upcoming,
        videos,
        songs: Array.isArray(data?.songs) ? data.songs : [],
        photos: Array.isArray(data?.photos) ? data.photos : [],
      });
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return content;
};
